import { render, staticRenderFns } from "./LocaleButtons.vue?vue&type=template&id=40ea9ca4&scoped=true&lang=pug&"
import script from "./LocaleButtons.vue?vue&type=script&lang=js&"
export * from "./LocaleButtons.vue?vue&type=script&lang=js&"
import style0 from "./LocaleButtons.vue?vue&type=style&index=0&id=40ea9ca4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ea9ca4",
  null
  
)

export default component.exports